import ProgressRing from './progress-ring';

export default ProgressRing;
